type UploadStartedListener = (notice: { fileCount: number }) => void;

const listeners = new Set<UploadStartedListener>();

/** Tell the upload manager a batch was just accepted, before progress polling catches up. */
export function announceUploadStarted(fileCount: number) {
  const notice = { fileCount: Math.max(0, fileCount) };
  for (const listener of listeners) {
    listener(notice);
  }
}

export function subscribeUploadStarted(listener: UploadStartedListener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
